import { API, graphqlOperation } from 'aws-amplify';
import { captureError } from '../common/sentry';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { printItem } from '../queries/queries';
import { ReceiptHeader } from '../common/types';

type PrintItemResponse = {
  printItem: string;
};

type PrintItemResult = {
  payload?: ReceiptHeader;
  error: string;
};

// Test-only virtual printer (ADO 27396): when the print lambda captured the
// label instead of printing (sentinel printer record), pop the viewer links.
// Inert unless the REACT_APP_VP_* env vars are set - they never are in Prod.
function notifyVirtualPrint(key: string) {
  const viewerBase = process.env.REACT_APP_VP_VIEWER_URL;
  const viewerToken = process.env.REACT_APP_VP_VIEWER_TOKEN;
  if (!viewerBase || !viewerToken) {
    return;
  }
  window.dispatchEvent(
    new CustomEvent('ftl:virtual-print', {
      detail: {
        pdfUrl: `${viewerBase}/label.pdf?key=${encodeURIComponent(key)}&t=${viewerToken}`,
        listUrl: `${viewerBase}/?t=${viewerToken}`
      }
    })
  );
}

export async function postPrintItem(body: string): Promise<PrintItemResult> {
  const genericResponseError = {
    payload: undefined,
    error: 'An error occurred while printing items.'
  };

  try {
    const result = (await API.graphql(graphqlOperation(printItem, { body }))) as GraphQLResult<PrintItemResponse>;

    if (result.data && result.data.printItem) {
      const printResult = JSON.parse(result.data.printItem);
      if (printResult.statusCode === 200) {
        if (printResult.virtualPrint && printResult.key) {
          notifyVirtualPrint(printResult.key);
        }
        return { payload: printResult.body, error: '' };
      }
    }
    return genericResponseError;
  } catch (e) {
    console.error('Error posting print: ', e);
    captureError(e, 'postPrintItem');
    return genericResponseError;
  }
}
